/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase, { ButtonProps } from '@material-ui/core/Button';
import CircularProgress, {
  CircularProgressProps,
} from '@material-ui/core/CircularProgress';

interface IButton {
  children: React.ReactChild;
  showLoading?: boolean;
  color?: string;
}

type Props = ButtonProps & IButton;

function ColoredCircularProgressBase(props: CircularProgressProps) {
  return <CircularProgress {...props} />;
}

const styles = () => ({
  colorPrimary: {
    color: '#fff',
  },
});

const ColoredCircularProgress = withStyles(styles)(ColoredCircularProgressBase);

const Button: React.FunctionComponent<Props> = ({
  children,
  showLoading,
  ...restProps
}) => (
  <ButtonBase {...restProps}>
    {showLoading ? <ColoredCircularProgress color='primary' /> : children}
  </ButtonBase>
);
export default Button;
export { Button };
